import EventEmitter from "../emitter/EventEmitter";
var RCTDeviceEventEmitter_default = new EventEmitter();
export {
  RCTDeviceEventEmitter_default as default
};
//# sourceMappingURL=RCTDeviceEventEmitter.js.map
